function zeroIze() {
  return this.length === 1 ? "0" + this : this;
}

String.prototype.$zeroIze = zeroIze;
